// Trois icones de la navigation compta que l'amont a retirees de sparkle (elagage des
// icones inutilisees, fusion de septembre 2026). Copiees telles quelles depuis
// sparkle/src/icons/v2-stroke a la revision 7276c61b2afd, pour que la navigation garde
// ses pictogrammes sans rouvrir de divergence dans sparkle.
import type { SVGProps } from "react";

const SvgBarChartSquare01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.965 7.8c0-.857 0-1.438-.037-1.886-.036-.436-.1-.656-.177-.807a1.97 1.97 0 0 0-.858-.858c-.151-.077-.37-.141-.807-.177-.448-.036-1.029-.037-1.886-.037H7.8c-.857 0-1.438 0-1.886.037-.436.036-.656.1-.807.177-.37.188-.67.489-.858.858-.077.151-.141.37-.177.807-.036.448-.037 1.029-.037 1.886v8.4c0 .857 0 1.438.037 1.886.036.436.1.656.177.807.188.37.489.67.858.858.151.077.37.141.807.177.448.036 1.029.037 1.886.037h8.4c.857 0 1.438 0 1.886-.037.436-.036.656-.1.807-.177.37-.188.67-.489.858-.858.077-.151.141-.37.177-.807.036-.448.037-1.029.037-1.886zm-13 9.2v-4a1.035 1.035 0 0 1 2.07 0v4a1.035 1.035 0 0 1-2.07 0m4 0V7a1.035 1.035 0 0 1 2.07 0v10a1.035 1.035 0 0 1-2.07 0m4 0v-6a1.035 1.035 0 0 1 2.07 0v6a1.035 1.035 0 0 1-2.07 0m7.07-.8c0 .823 0 1.503-.045 2.055-.046.564-.145 1.086-.395 1.577a4.03 4.03 0 0 1-1.763 1.763c-.491.25-1.013.35-1.577.395-.552.045-1.232.045-2.055.045H7.8c-.823 0-1.503 0-2.055-.045-.564-.046-1.086-.145-1.577-.395a4.03 4.03 0 0 1-1.763-1.763c-.25-.491-.35-1.013-.395-1.577-.045-.552-.045-1.232-.045-2.055V7.8c0-.823 0-1.503.045-2.055.046-.564.145-1.086.395-1.577a4.03 4.03 0 0 1 1.763-1.763c.491-.25 1.013-.35 1.577-.395.552-.045 1.232-.045 2.055-.045h8.4c.823 0 1.503 0 2.055.045.564.046 1.086.145 1.577.395a4.03 4.03 0 0 1 1.763 1.763c.25.491.35 1.013.395 1.577.045.552.045 1.232.045 2.055z"
    />
  </svg>
);

const SvgLayoutGrid01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19.965 13.035h-6.93v6.93H16.2c.857 0 1.438 0 1.886-.037.436-.036.656-.1.807-.177.37-.188.67-.489.858-.858.077-.151.141-.37.177-.807.036-.448.037-1.029.037-1.886zM4.035 16.2c0 .857 0 1.438.037 1.886.036.436.1.656.177.807.188.37.489.67.858.858.151.077.37.141.807.177.448.036 1.029.037 1.886.037h3.165v-6.93h-6.93zm15.93-8.4c0-.857 0-1.438-.037-1.886-.036-.436-.1-.656-.177-.807a1.97 1.97 0 0 0-.858-.858c-.151-.077-.37-.141-.807-.177-.448-.036-1.029-.037-1.886-.037h-3.165v6.93h6.93zm-15.93 3.165h6.93v-6.93H7.8c-.857 0-1.438 0-1.886.037-.436.036-.656.1-.807.177-.37.188-.67.489-.858.858-.077.151-.141.37-.177.807-.036.448-.037 1.029-.037 1.886zm18 5.235c0 .823 0 1.503-.045 2.055-.046.564-.145 1.086-.395 1.577a4.03 4.03 0 0 1-1.763 1.763c-.491.25-1.013.35-1.577.395-.552.045-1.232.045-2.055.045H7.8c-.823 0-1.503 0-2.055-.045-.564-.046-1.086-.145-1.577-.395a4.03 4.03 0 0 1-1.763-1.763c-.25-.491-.35-1.013-.395-1.577-.045-.552-.045-1.232-.045-2.055V7.8c0-.823 0-1.503.045-2.055.046-.564.145-1.086.395-1.577a4.03 4.03 0 0 1 1.763-1.763c.491-.25 1.013-.35 1.577-.395.552-.045 1.232-.045 2.055-.045h8.4c.823 0 1.503 0 2.055.045.564.046 1.086.145 1.577.395a4.03 4.03 0 0 1 1.763 1.763c.25.491.35 1.013.395 1.577.045.552.045 1.232.045 2.055z"
    />
  </svg>
);

const SvgPercent01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M18.269 4.269A1.034 1.034 0 1 1 19.73 5.73l-14 14A1.034 1.034 0 1 1 4.27 18.27zM17.5 17.465a.035.035 0 0 0-.035.035c0 .02.016.035.035.035q.015 0 .024-.01l.011-.025-.01-.024a.04.04 0 0 0-.025-.011m-11-11a.035.035 0 0 0-.035.035c0 .02.016.035.035.035q.015 0 .024-.01l.011-.025-.01-.024a.04.04 0 0 0-.025-.011M19.535 17.5a2.035 2.035 0 1 1-4.07 0 2.035 2.035 0 0 1 4.07 0m-11-11a2.035 2.035 0 0 1-4.06.208l-.01-.208.01-.208A2.035 2.035 0 0 1 6.5 4.465l.208.01A2.035 2.035 0 0 1 8.535 6.5"
    />
  </svg>
);

export {
  SvgBarChartSquare01 as BarChartSquare01,
  SvgLayoutGrid01 as LayoutGrid01,
  SvgPercent01 as Percent01,
};
